import AuthBase from "../AuthBase";
import {Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import {useEffect, useState} from "react";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import Loading from "../../components/Loading";
import _ from "lodash";
import WorkHourPicker from "../../components/WorkHourPicker";
import Leaves from "./components/Leaves";
import {useSnackbar} from "notistack";
import useBusinessQueries from "../../hooks/queries/useBusinessQueries";
import useWorkHourQueries from "../../hooks/queries/useWorkHourQueries";
import workHourTemplate from "./WorkHourTemplate";


const OpeningHours = () => {
    const {enqueueSnackbar} = useSnackbar()
    const {workHourForBusinessQuery, updateWorkHourBusinessMutation} = useWorkHourQueries()
    const {businessGetBusinessQuery} = useBusinessQueries()
    const {data: business, isPending: businessLoading} = businessGetBusinessQuery
    const {data: openingHours, isPending: openingHoursLoading} = workHourForBusinessQuery
    const [editedOpeningHours, setEditedOpeningHours] = useState(workHourTemplate)

    useEffect(() => {
        if (openingHours) {
            setEditedOpeningHours(_.cloneDeep(openingHours))
        }
    }, [openingHours])

    const hasUnsavedChanges = JSON.stringify(openingHours) !== JSON.stringify(editedOpeningHours)


    const savePageData = () => {
        updateWorkHourBusinessMutation.mutate(editedOpeningHours, {
            onSuccess: response => {
                console.log(response)
                setEditedOpeningHours(_.cloneDeep(response))
                enqueueSnackbar('Mentve', {variant: 'success'})
            }
        })
    }


    const buttons = [{
        name: 'Változtatások mentése',
        props: {
            endIcon: <SaveRoundedIcon/>,
            variant: 'contained',
            size: 'large',
            disabled: !hasUnsavedChanges,
            onClick: savePageData
        }
    }]

    const buttonsMobile = [{
        name: 'Mentés',
        props: {
            endIcon: <SaveRoundedIcon/>,
            variant: 'contained',
            size: 'small',
            disabled: !hasUnsavedChanges,
            onClick: savePageData
        }
    }]

    if (businessLoading || openingHoursLoading) return <Loading isLoading />

    return <AuthBase label='Nyitvatartás' buttons={buttons} filterButtonsMobile={buttonsMobile}>
        <div className="main">
            <Grid container spacing={2}>

                {/*Opening hours*/}
                <Grid item xs={12}>
                    <div className="white-card">
                        <Typography variant='subtitle1'>Nyitvatartási idő</Typography>
                        <Typography variant='body2' color='#536B74'>
                            Add meg mikor van nyitva vállalkozásod. A
                            kollégáknál csak ebben az idő intevallumban lehet foglalni időpontot!
                        </Typography>
                        <Typography variant='body2' color='#ff0000' marginBottom={2}>
                            Ez az menüpont a lábléc szekcióban látható nyitvatartást állítja, ami független a kollégák
                            munkaidejétől!
                            Amennyiben azt szeretnéd módosítani, hogy mely időpontok legyenek elérhetőek a
                            foglaló felületen, azt a <a href='/colleagues'>kollégák</a> menüpontban tudod megtenni.
                        </Typography>
                        <WorkHourPicker
                            editedOpeningHours={editedOpeningHours}
                            setEditedOpeningHours={setEditedOpeningHours}
                        />
                    </div>
                </Grid>

                {/*Leaves*/}
                <Grid item xs={12}>
                    <Leaves businessId={business?.id}/>
                </Grid>
            </Grid>
        </div>

    </AuthBase>
}

export default OpeningHours